import {useEffect, useState} from "react";
import {getInventoryByProduct} from "../../api/Api";
import {Select} from "antd";

export const InventoryAssignmentWidget = ({productId, refresh, onSelect, onRefresh, onApiFail, props}) => {
    const [inventory, setInventory] = useState([]);
    const [value, setValue] = useState(undefined);
    const [active, setActive] = useState(true);

    useEffect(() => {
        getInventoryByProduct(productId).then((x) => {
            const tableData = x.map((val) => {
                return {...val, key: val.id}
            }).filter(val => val.quantity > 0);
            setInventory(tableData);
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        });
    }, [refresh, onApiFail, productId]);

    const productOptions = inventory.map((val, index) => {
        return {
            value: val,
            label:  `${val.quantity} available, SKU: ${val.sku} `,
            key: val.id
        }
    })


    const onItemSelect = (val) => {
        setValue(val);
        if (onSelect) {
            onSelect(val)
        }
        setActive(false);
    }

    const onClick  = () => {
        setActive(true);
    }

    if (active) {
        return <Select value={value} options={productOptions} onSelect={onItemSelect} placeholder={`select inventory`}
                       popupMatchSelectWidth={false}/>
    } else {
        return <div onClick={onClick} style={{cursor: 'pointer', color: "#108ee9"}}>Assigned - {`${value.sku}`}</div>
    }
}